import { featureFlagStore } from './featureFlagStore';
import { IFeatureFlagStoreActions } from './types';

export const toggleFeatureFlag: IFeatureFlagStoreActions['toggleFeatureFlag'] = ({ name }) => {
  featureFlagStore.setState((state) => ({
    featureFlags: state.featureFlags.map((featureFlag) => ({
      ...featureFlag,
      enabled: featureFlag.name === name ? !featureFlag.enabled : featureFlag.enabled,
    })),
  }));
};
